// not supported for iOS < 16.4
export const { isScreenOrientationSupported } = window.Playtech.Data;

export const getId = () => window.Playtech.Methods.getId();

export const getDevice = () => {
    return {
        ...window.Playtech.Methods.getDevice()
    };
};
